import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import '../../../../../assets/css/glossaryTerm.css';
import { outcomeCardsCss } from './outcomeCards.styles';

export const SlideContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  margin-top: 30px;
  padding: 20px 30px;
  box-sizing: border-box;
`;

export const SlideWithImage = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: 0,
  alignItems: 'flex-start',
  width: '100%',
  minHeight: '50vh',

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column-reverse',
  },
}));

export const SlideImageContainer = styled(Box)`
  flex: 1;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ImgElement = typeof Image !== 'undefined' ? Image : 'img';
export const SlideImage = styled(ImgElement)`
  max-width: 100%;
  max-height: 460px;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;
`;

export const SlidePointsContainer = styled(Box)`
  flex: 1;
`;

export const SlideTitleContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex: 1;
`;

// Single point with larger image
export const SlideSinglePointWithImage = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
`;

export const SlidePoint = styled(Box)`
  padding: 20px 0;
  border-radius: 8px;
  transition: transform 0.2s ease;
  width: 100%;
  text-align: left;

  ${outcomeCardsCss}
`;

export const PointTitle = styled(Typography)`
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 18px;
  color: var(--brand-text, #000);
  font-weight: 600;
`;

export const PointText = styled(Typography)`
  margin: 0;
  color: var(--brand-text, #000);
  line-height: 1.6;
  font-size: 20px;
  text-align: left;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  /* Prevent drag */
  -webkit-user-drag: none;

  /* Disable context menu on right-click */
  pointer-events: auto;
`;

export const SinglePoint = styled(SlidePoint)`
  max-width: 100%;
  font-size: 1.1em;
`;

export const SlideTitle = styled(Typography)(({ theme }) => ({
  width: '100%',
  textAlign: 'left',
  marginBottom: '30px',
  fontSize: '35px',
  color: '#EE6D29',
  fontWeight: 700,
  position: 'relative',
  paddingBottom: '15px',
  userSelect: 'none',
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  WebkitUserDrag: 'none',
  pointerEvents: 'auto',

  [theme.breakpoints.down('sm')]: {
    fontSize: '23px',
    marginBottom: '5px',
  },
}));

export const SlideList = styled(Box)`
  padding: 20px 0;
  border-radius: 8px;
  min-height: 47vh;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  /* Prevent drag */
  -webkit-user-drag: none;

  /* Disable context menu on right-click */
  pointer-events: auto;

  ul {
    padding-left: 20px;
    text-align: left;
  }

  li {
    margin-bottom: 12px;
    font-size: clamp(16px, 2vw, 21px);
    color: var(--brand-text, #000);
    line-height: 1.6;
    list-style-type: disc;
  }
`;

export const ContentContainer = styled(Box)`
  flex: 1;
  width: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  box-sizing: border-box;
`;

export const ImagePlaceholder = styled(Box)`
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 75%;
  height: auto;
  min-height: 200px;
  margin: 16px auto;
  overflow: hidden;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
`;

export const ContentBulletItem = styled(Box)`
  display: flex;
  margin-bottom: 12px;
  line-height: 1.6;
  text-align: left;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  pointer-events: auto;

  &::before {
    content: "•";
    font-size: 24px;
    color: var(--brand-text, #000);
    margin-right: 12px;
    flex-shrink: 0;
    line-height: 1.6;
  }
`;

export const ContentItemText = styled(Typography)`
  font-size: 20px;
  color: var(--brand-text, #000);
  line-height: 1.6;

  strong {
    font-weight: 700;
  }
`;

export const ContentSubheading = styled(Typography)`
  font-weight: 700;
  font-size: 22px;
  color: var(--brand-text, #000);
  margin-top: 20px;
  margin-bottom: 10px;
  line-height: 1.4;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  pointer-events: auto;
`;

export const ContentText = styled(Typography)`
  font-size: 20px;
  color: var(--brand-text, #000);
  line-height: 1.6;
  margin-bottom: 15px;
  text-align: left;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  pointer-events: auto;
`;

export const SlideDescription = styled(Box)`
  line-height: 1.7;
  color: var(--brand-text, #000);
  font-size: 18px;
  padding: 20px 0;
  max-width: 100%;
  width: 100%;
  text-align: left;
  border-radius: 8px;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  /* Prevent drag */
  -webkit-user-drag: none;

  /* Disable context menu on right-click */
  pointer-events: auto;

  .content-so-what {
    font-size: 0.95rem;
    font-weight: 700;
    color: #065f46;
    background: #ecfdf5;
    border-radius: 10px;
    padding: 12px 16px;
    margin-top: 18px;
    margin-bottom: 12px;
    line-height: 1.55;
    text-align: left;
    border-left: 3px solid #10b981;
    width: 100%;
    box-sizing: border-box;

    &::before {
      content: "";
    }
  }

  .content-feedback-chosen {
    font-size: 0.95rem;
    font-weight: 700;
    color: #991b1b;
    background: #fef2f2;
    border-radius: 10px;
    padding: 12px 16px;
    margin-top: 0px;
    margin-bottom: 16px;
    line-height: 1.55;
    text-align: left;
    border-left: 3px solid #ef4444;
    width: 100%;
    box-sizing: border-box;

    &::before {
      content: "";
    }
  }

  .recap-list {
    margin-bottom: 18px;
    padding-left: 24px;
    text-align: left;
    width: 100%;

    li {
      margin-bottom: 8px;
      line-height: 1.5;
      font-size: 1rem;
      color: #374151;
      text-align: left;

      strong {
        color: #1e3a8a;
        font-weight: 800;
      }
    }
  }
`;

export const VideoLayout = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100%;
  min-height: 0;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-drag: none;
  pointer-events: auto;
`;

export const HtmlContentLayout = styled(Box)`
  display: flex;
  gap: 24px;
  width: 100%;
  align-items: stretch;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

export const HtmlImageContainer = styled(Box)`
  flex: 0 0 40%;
  display: flex;
  flex-direction: column;
  align-items: center;

  &::before {
    content: "";
    display: block;
    flex: 1;
  }

  &::after {
    content: "";
    display: block;
    flex: 4;
  }

  @media (max-width: 960px) {
    flex: 1;
    width: 100%;

    &::before,
    &::after {
      display: none;
    }
  }
`;

export const HtmlContentColumn = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const HtmlContentWrapper = styled(Box)`
  width: 100%;
  line-height: 1.6;
  font-size: 18px;
  text-align: left;
  color: var(--brand-text, #000);
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  & * {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-user-drag: none;
    pointer-events: auto;
  }

  /* Storytelling templates styles */
  .scenario-text {
    font-size: 1.1rem;
    color: #1f2937;
    margin-bottom: 16px;
    line-height: 1.6;
  }

  .speech-bubble {
    position: relative;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 16px;
    margin-top: 12px;
    margin-bottom: 16px;
    font-size: 1.05rem;
    font-style: italic;
    color: #111827;
    line-height: 1.5;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    &::before {
      content: '💬';
      position: absolute;
      left: -12px;
      top: 14px;
      font-size: 1.25rem;
      background: white;
      border-radius: 50%;
      padding: 2px;
    }
  }

  .reveal-big {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 16px;
    text-align: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    .answer-label {
      font-size: 0.85rem;
      font-weight: 700;
      color: #64748b;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-bottom: 6px;
    }

    .answer {
      font-size: 1.4rem;
      font-weight: 800;
      color: #0f172a;
      margin-bottom: 8px;
    }

    .reason {
      font-size: 0.95rem;
      color: #475569;
      line-height: 1.5;
    }
  }

  .action-line {
    background: #f0fdfa;
    border-left: 4px solid #14b8a6;
    border-radius: 0 8px 8px 0;
    padding: 12px 16px;
    font-size: 1rem;
    color: #0d9488;
    line-height: 1.5;
    margin-bottom: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  /* Content points and frameworks styling */
  .content-hook {
    font-size: 1.15rem;
    font-weight: 500;
    color: #1f2937;
    margin-bottom: 18px;
    line-height: 1.6;
  }

  .content-body {
    font-size: 1rem;
    color: #374151;
    margin-bottom: 18px;
    text-align: left;
    width: 100%;

    p {
      margin-bottom: 12px;
      text-align: left;
    }
  }

  .recap-list {
    margin-bottom: 18px;
    padding-left: 20px;

    li {
      margin-bottom: 8px;
      line-height: 1.5;
      font-size: 1rem;
      color: #374151;

      strong {
        color: #1e3a8a;
        font-weight: 800;
      }
    }
  }

  .info-box {
    margin-top: 16px;
    margin-bottom: 18px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 14px 18px;

    .label {
      display: inline-block;
      font-size: 0.75rem;
      font-weight: 800;
      color: #475569;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-bottom: 4px;
    }

    p {
      font-size: 1rem;
      font-style: italic;
      color: #334155;
      margin: 0;
      line-height: 1.5;
    }
  }

  .content-so-what {
    font-size: 0.95rem;
    font-weight: 700;
    color: #065f46;
    background: #ecfdf5;
    border-radius: 10px;
    padding: 12px 16px;
    margin-top: 18px;
    margin-bottom: 12px;
    line-height: 1.55;
    text-align: left;
    border-left: 3px solid #10b981;

    &::before {
      content: "";
    }
  }

  .content-feedback-chosen {
    font-size: 0.95rem;
    font-weight: 700;
    color: #991b1b;
    background: #fef2f2;
    border-radius: 10px;
    padding: 12px 16px;
    margin-top: 0px;
    margin-bottom: 16px;
    line-height: 1.55;
    text-align: left;
    border-left: 3px solid #ef4444;

    &::before {
      content: "";
    }
  }

  /* Learning Objective (slo_title) styles */
  .slo-title-card {
    margin-top: 30px;
    padding: 0 20px;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    .slo-title-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
    }

    .slo-title-icon {
      font-size: 1.3rem;
      line-height: 1;
    }

    .slo-title-kicker {
      font-size: 1.05rem;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: #6366f1;
      font-weight: 700;
    }

    .slo-title-main {
      font-size: 1.85rem;
      font-weight: 800;
      color: #0f172a;
      margin: 20px 0 0 0;
      line-height: 1.35;
      text-align: left;
      letter-spacing: -0.02em;
    }
  }

  /* Key Learning Points styles */
  .intro-line {
    text-align: left;
    font-size: 1rem;
    color: #475569;
    margin-bottom: 12px;
    line-height: 1.5;
  }

  .key-points {
    list-style: none;
    padding: 0;
    margin: 16px 0;
    display: flex;
    flex-direction: column;
    gap: 12px;

    li {
      font-size: 1rem;
      padding: 14px 18px;
      background: #f1f5f9;
      border-radius: 12px;
      display: grid;
      grid-template-columns: 28px 1fr;
      gap: 14px;
      align-items: center;

      &.no-icon {
        display: block;
      }

      &:not(:has(.icon)) {
        display: block;
      }

      .icon {
        font-size: 1.4rem;
        line-height: 1;
      }

      .key-point-copy {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .key-point-phrase strong {
        color: #0f172a;
        font-weight: 700;
      }

      .key-point-desc {
        font-size: 0.875rem;
        color: #475569;
        line-height: 1.45;
      }
    }
  }

  .key-points-closing {
    margin-top: 16px;
    padding: 12px 16px;
    border-radius: 12px;
    background: #fff7ed;
    color: #9a3412;
    font-size: 0.95rem;
    line-height: 1.5;
    border: 1px solid #fed7aa;
  }

  /* Celebration & Badge Slide Styles */
  .celebration-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    padding: 10px 20px;
    margin-top: 10px;

    .celebration-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 12px 36px;
      border-radius: 9999px;
      background: linear-gradient(135deg, #f59e0b, #d97706);
      color: #ffffff;
      font-weight: 700;
      font-size: 1.2rem;
      margin-bottom: 24px;
      box-shadow: 0 4px 14px rgba(245, 158, 11, 0.3);
      letter-spacing: 0.02em;
    }

    .celebration-message {
      font-size: 1.85rem;
      font-weight: 800;
      color: #0f172a;
      line-height: 1.35;
      margin: 0 0 28px 0;
      max-width: 850px;
      text-align: center;
    }

    .celebration-recaps {
      list-style: disc;
      padding-left: 24px;
      margin: 0;
      text-align: left;
      display: inline-block;
      max-width: 750px;

      li {
        font-size: 1.15rem;
        color: #1e293b;
        line-height: 1.6;
        margin-bottom: 12px;
      }
    }
  }

  /* Illustrative example badge style */
  .illustrative-badge {
    display: inline-block;
    margin-bottom: 14px;
    padding: 4px 12px;
    border-radius: 999px;
    background: #fef3c7;
    color: #92400e;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    border: 1px solid #fde68a;
    line-height: 1.2;
  }

  /* ContentNew: taxonomy, spectrum, sequence, watchouts, negspace */
  .taxonomy-wrapper {
    margin-top: 12px;
    margin-bottom: 20px;
  }

  .taxonomy-item {
    margin-bottom: 12px;
    line-height: 1.5;
    font-size: 1rem;

    .taxonomy-number {
      font-weight: 800;
      color: #1e3a8a;
    }

    .taxonomy-title {
      font-weight: 800;
      color: #1e3a8a;
      font-size: 1.05rem;
    }

    .taxonomy-sep {
      color: #9ca3af;
    }

    .taxonomy-explanation {
      color: #374151;
    }
  }

  .spectrum-container {
    margin-top: 12px;
    margin-bottom: 18px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .spectrum-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    border-bottom: 1px solid #e2e8f0;

    @media (max-width: 640px) {
      grid-template-columns: 1fr;

      .spectrum-card.wrong {
        border-right: none;
        border-bottom: 1px solid #e2e8f0;
      }
    }
  }

  .spectrum-card {
    padding: 12px 16px;
    text-align: center;

    &.wrong {
      background: #fff5f5;
      border-right: 1px solid #e2e8f0;
    }

    &.right {
      background: #f0fdf4;
    }
  }

  .spectrum-label {
    font-weight: 800;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 4px;
    text-align: left;

    &.wrong {
      color: #b91c1c;
    }

    &.right {
      color: #15803d;
    }
  }

  .spectrum-value {
    font-size: 0.9rem;
    text-align: left;

    &.wrong {
      color: #991b1b;
    }

    &.right {
      color: #166534;
    }
  }

  .spectrum-details {
    padding: 12px;
    background: #ffffff;
    font-size: 0.9rem;
    color: #475569;
    line-height: 1.5;
    text-align: center;
    font-style: italic;
  }

  .sequence-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 12px;
    margin-bottom: 18px;
  }

  .sequence-card {
    flex: 1;
    min-width: 240px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    padding: 14px;
    border-radius: 8px;

    &.before {
      background: #f8fafc;
      border-color: #e2e8f0;
    }

    &.after {
      background: #f0fdf4;
      border-color: #dcfce7;
    }
  }

  .sequence-title {
    font-weight: 800;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 10px;
    padding-bottom: 6px;
    border-bottom: 2px solid;

    &.before {
      color: #475569;
      border-bottom-color: #cbd5e1;
    }

    &.after {
      color: #166534;
      border-bottom-color: #bbf7d0;
    }
  }

  .sequence-step {
    margin-bottom: 8px;
    font-size: 0.9rem;
    line-height: 1.45;

    .sequence-arrow {
      color: #94a3b8;
    }

    .sequence-action {
      font-weight: 700;
      color: #334155;
    }

    .sequence-explanation {
      color: #4b5563;
    }

    .sequence-card.after & {
      .sequence-arrow {
        color: #22c55e;
      }
      .sequence-action {
        color: #14532d;
      }
    }
  }

  .watch-outs-container {
    margin-top: 18px;
    margin-bottom: 12px;
    padding: 12px 16px;
    background: #fff5f5;
    border-left: 4px solid #ef4444;
    border-radius: 4px;
  }

  .watch-outs-title {
    font-weight: 800;
    color: #991b1b;
    font-size: 0.85rem;
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .watch-out-item {
    font-size: 0.9rem;
    color: #7f1d1d;
    line-height: 1.45;
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .negative-space-container {
    margin-top: 18px;
    margin-bottom: 12px;
    padding: 12px 16px;
    background: #f8fafc;
    border-left: 4px solid #64748b;
    border-radius: 4px;
    font-size: 0.9rem;
    color: #475569;
    line-height: 1.45;
  }

  /* ContentMore: narrative layouts gap, buffer, collapse */
  .narrative-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 14px;
    margin-top: 12px;
    margin-bottom: 16px;
  }

  .narrative-card {
    border-radius: 8px;
    padding: 14px;
    border: 1px solid;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    &.old-workflow {
      background: #fff5f5;
      border-color: #fee2e2;
    }

    &.new-workflow {
      background: #f0fdf4;
      border-color: #dcfce7;
    }

    &.tempting-shortcut {
      background: #fffbeb;
      border-color: #fef3c7;
    }

    &.safety-buffer {
      background: #f0fdf4;
      border-color: #dcfce7;
    }
  }

  .narrative-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  .narrative-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-weight: 900;
    font-size: 0.75rem;

    &.old-workflow {
      background: #fee2e2;
      color: #ef4444;
    }

    &.new-workflow {
      background: #dcfce7;
      color: #22c55e;
    }

    &.tempting-shortcut {
      font-size: 0.95rem;
      background: transparent;
    }

    &.safety-buffer {
      font-size: 0.95rem;
      background: transparent;
    }
  }

  .narrative-title {
    font-weight: 800;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;

    &.old-workflow { color: #991b1b; }
    &.new-workflow { color: #14532d; }
    &.tempting-shortcut { color: #92400e; }
    &.safety-buffer { color: #14532d; }
  }

  .narrative-text {
    font-size: 0.9rem;
    margin: 0;
    line-height: 1.45;

    &.old-workflow { color: #7f1d1d; }
    &.new-workflow { color: #14532d; }
    &.tempting-shortcut { color: #78350f; }
    &.safety-buffer { color: #14532d; }
  }

  .narrative-collapse-container {
    margin-top: 12px;
    margin-bottom: 16px;
    border: 1px solid #fecaca;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .narrative-collapse-header {
    background: #fffbeb;
    padding: 12px;
    border-bottom: 1px solid #fecaca;
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }

  .narrative-collapse-body {
    background: #fff5f5;
    padding: 14px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }

  .narrative-collapse-icon {
    font-size: 1.15rem;
    line-height: 1;

    &.crash {
      font-size: 1.5rem;
    }
  }

  .narrative-collapse-header-text,
  .narrative-collapse-body-text {
    flex: 1;
  }

  .narrative-collapse-title {
    font-weight: 800;
    font-size: 0.8rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 3px;

    &.warning { color: #92400e; }
    &.crash { color: #991b1b; }
  }

  .narrative-collapse-desc {
    font-size: 0.9rem;
    color: #78350f;
    line-height: 1.45;

    &.crash {
      font-size: 0.95rem;
      color: #7f1d1d;
      font-weight: 600;
    }
  }

  .downstream-outcome {
    margin-top: 14px;
    margin-bottom: 14px;
    font-size: 0.95rem;
    color: #374151;
    line-height: 1.5;
  }

  .final-warning-container,
  .term-definition-container {
    margin-top: 14px;
    margin-bottom: 14px;
    padding: 12px;
    background: #fffbeb;
    border-left: 4px solid #d97706;
    border-radius: 4px;
    font-size: 0.95rem;
    color: #78350f;
    line-height: 1.45;
  }

  ${outcomeCardsCss}
`;
